import { inject } from '../common/container/inject';
import { ILearningRootService, LearningRootServiceToken } from '../service/LearningRootService';

export enum ImageUrlError {
  InvalidFormat = 'invalid_format',
  RemoteValidationFailed = 'remote_validation_failed',
}

export async function validateImageUrl(url: string): Promise<ImageUrlError | null> {
  let parsed: URL;

  try {
    parsed = new URL(url);
  } catch {
    return ImageUrlError.InvalidFormat;
  }

  if (!['http:', 'https:'].includes(parsed.protocol)) {
    return ImageUrlError.InvalidFormat;
  }

  const allowedExtensions = /\.(png|jpe?g)$/i;
  if (!allowedExtensions.test(parsed.pathname)) {
    return ImageUrlError.InvalidFormat;
  }

  const learningRootService = inject<ILearningRootService>(LearningRootServiceToken);

  try {
    const isImage = await learningRootService.utils.checkImageUrl(url);
    if (!isImage) {
      return ImageUrlError.RemoteValidationFailed;
    }
  } catch {
    return ImageUrlError.RemoteValidationFailed;
  }

  return null;
}
